import {limitBets} from "../../stores/util";

class Game {
    constructor(props) {
        this.num = props.num;
        this.mark = props.mark;
        this.titles = props.titles;
        this.position = props.position;
        this.positionView = props.positionView;
        this.positionMin = props.positionMin;
        this.balls = props.balls;
        this.views = props.views;
        this.limitBet = props.limitBet || false;
        this.dantuo = props.dantuo || false;
        this.dantuoNum = props.dantuoNum || 1;
        this.isInput = props.isInput || 0;
        this.desc = props.desc || '';
        this.eg = props.eg || '';
        this.chooseType = props.chooseType || [];
        this.getNum = props.getNum;
        this.id = props.id;
        this.getView = props.getView;
        this.getBalls = props.getBalls;
        this.showTuoType = props.showTuoType || false;
        this.getLottery = props.getLottery;
        this.limitBets = limitBets;
    }
}

export default Game;